const enrollmentQuery = {
    "enableCertificatePhoto": true,
    "enrollment": [
        {
            "code": "TAF-QM110049",
            "name": "實驗室認證規範ISO/IEC 17025訓練",
            "classDate": "2021/10/12~2021/10/14",
            "location": "線上",
            "edit": false,
            "status": "apply",
            "paymentSlip": {},
            "classOpening": {},
            "participationCertificate": {},
            "participationCertificateDownload": true,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": true
        },
        {
            "code": "TAF-MH110002",
            "name": "醫學實驗室主管訓練",
            "classDate": "2021/10/20~2021/10/22",
            "location": "線上",
            "edit": false,
            "status": "apply",
            "paymentSlip": {},
            "classOpening": {},
            "participationCertificate": {},
            "participationCertificateDownload": true,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": true
        },
        {
            "code": "TAF-IB110006",
            "name": "檢驗機構認證規範ISO/IEC 17020與ILAC-P15訓練",
            "classDate": "2021/10/28~2021/10/29",
            "location": "線上",
            "edit": false,
            "status": "apply",
            "paymentSlip": {},
            "classOpening": {},
            "participationCertificate": {},
            "participationCertificateDownload": true,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": false
        },
        {
            "code": "TAF-QP110004",
            "name": "產品驗證機構認證規範ISO/IEC 17065訓練",
            "classDate": "2021/12/07~2021/12/08",
            "location": "台北",
            "edit": false,
            "status": "cancel",
            "paymentSlip": {},
            "classOpening": {},
            "participationCertificate": {},
            "participationCertificateDownload": false,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": false
        },
        {
            "code": "TAF-TH110012",
            "name": "測試實驗室主管訓練",
            "classDate": "2022/01/30~2022/01/31",
            "location": "高雄",
            "cost": "新台幣5500",
            "edit": false,
            "status": "cancel",
            "paymentSlip": {},
            "classOpening": {},
            "participationCertificate": {},
            "participationCertificateDownload": false,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": false,
            "enrollmentInfo": {
                "chineseName": "陳志明",
                "englishName": "Chen Zhiming",
                "mobilePhone": "0912-112-221",
                "mailingAddress": {
                    "country": "TW",
                    "city":"taipei",
                    "district":"中正區",
                    "street":"忠孝東路",
                    "zipCode":"100"
                },
                "email": "chenZhiming@gmail.com",
                "accreditedLaboratory": "N",
                "applyCredit": "unnecessary",
                "contactPerson": {
                    "sameAsStudentInformation": true,
                    "name": "陳志明",
                    "email": "chenZhiming@gmail.com",
                    "mobilePhone": "0912-112-221",
                },
                "billInfo": {
                    "identity": "company",
                    "company": "股份有限公司",
                    "department": "開發部門",
                    "invoiceTitle": "股份有限公司",
                    "invoiceType": "triplicate",
                    "taxIdNo": "21338428",
                }
            }
        },
        {
            "code": "TAF-LG110012",
            "name": "實驗室內部稽核研討會",
            "classDate": "2022/01/09~2021/01/10",
            "location": "台中",
            "cost": "新台幣5500",
            "edit": true,
            "status": "waiting",
            "ranking": "23",
            "paymentSlip": {},
            "classOpening": {},
            "participationCertificate": {},
            "participationCertificateDownload": false,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": false,
            "enrollmentInfo": {
                "chineseName": "陳志明",
                "englishName": "Chen Zhiming",
                "mobilePhone": "0912-112-221",
                "mailingAddress": {
                    "country": "TW",
                    "city":"taipei",
                    "district":"中正區",
                    "street":"忠孝東路",
                    "zipCode":"100"
                },
                "email": "chenZhiming@gmail.com",
                "accreditedLaboratory": "N",
                "applyCredit": "unnecessary",
                "contactPerson": {
                    "sameAsStudentInformation": true,
                    "name": "陳志明",
                    "email": "chenZhiming@gmail.com",
                    "mobilePhone": "0912-112-221",
                },
                "billInfo": {
                    "identity": "company",
                    "company": "股份有限公司",
                    "department": "開發部門",
                    "invoiceTitle": "股份有限公司",
                    "invoiceType": "triplicate",
                    "taxIdNo": "21338428",
                }
            }
        },
        {
            "code": "TAF-MU110008",
            "name": "量測不確定度研討會(基礎班)",
            "classDate": "2022/02/22~2021/02/24",
            "location": "台中",
            "cost": "新台幣5500",
            "edit": true,
            "status": "apply",
            "paymentSlip": {},
            "classOpening": {},
            "participationCertificate": {},
            "participationCertificateDownload": true,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": false,
            "enrollmentInfo": {
                "chineseName": "陳志明",
                "englishName": "Chen Zhiming",
                "mobilePhone": "0912-112-221",
                "mailingAddress": {
                    "country": "TW",
                    "city":"taipei",
                    "district":"中正區",
                    "street":"忠孝東路",
                    "zipCode":"100"
                },
                "email": "chenZhiming@gmail.com",
                "accreditedLaboratory": "N",
                "applyCredit": "unnecessary",
                "contactPerson": {
                    "sameAsStudentInformation": true,
                    "name": "陳志明",
                    "email": "chenZhiming@gmail.com",
                    "mobilePhone": "0912-112-221",
                },
                "billInfo": {
                    "identity": "company",
                    "company": "股份有限公司",
                    "department": "開發部門",
                    "invoiceTitle": "股份有限公司",
                    "invoiceType": "triplicate",
                    "taxIdNo": "21338428",
                }
            }
        },
        {
            "code": "TAF-PT110002",
            "name": "能力試驗執行機構認證規範ISO/IEC 17043訓練",
            "classDate": "2022/03/03~2021/03/04",
            "location": "台北",
            "cost": "新台幣5500",
            "status": "apply",
            "edit": true,
            "paymentSlip": {},
            "classOpening": {},
            "participationCertificate": {},
            "participationCertificateDownload": true,
            "qualifiedCertificate": {},
            "qualifiedCertificateDownload": true,
            "enrollmentInfo": {
                "chineseName": "陳志明",
                "englishName": "Chen Zhiming",
                "mobilePhone": "0912-112-221",
                "mailingAddress": {
                    "country": "TW",
                    "city":"taipei",
                    "district":"中正區",
                    "street":"忠孝東路",
                    "zipCode":"100"
                },
                "email": "chenZhiming@gmail.com",
                "accreditedLaboratory": "N",
                "applyCredit": "unnecessary",
                "contactPerson": {
                    "sameAsStudentInformation": true,
                    "name": "陳志明",
                    "email": "chenZhiming@gmail.com",
                    "mobilePhone": "0912-112-221",
                },
                "billInfo": {
                    "identity": "company",
                    "company": "股份有限公司",
                    "department": "開發部門",
                    "invoiceTitle": "股份有限公司",
                    "invoiceType": "triplicate",
                    "taxIdNo": "21338428",
                }
            }
        },
    ]
};

export default enrollmentQuery;